import { CampaignIcon, DataSourcesIcon, DestinationsIcon } from '@/lib';
import { StepArgs } from '@/lib/Steppers';
import { ConnectAudienceStepIcon, SelectAudienceStepIcon } from './icons';
import { CreateCampaignStep, CreateCampaignStepHints } from './types';

export const CREATE_CAMPAIGN_STEPS = [
  {
    id: 'CreateNewCampaign',
    icon: CampaignIcon,
    title: 'createNewCampaign',
  },
  {
    id: 'ImportDataSource',
    icon: DataSourcesIcon,
    title: 'importDataSource',
  },
  {
    id: 'ChooseDestination',
    icon: DestinationsIcon,
    title: 'chooseDestination',
  },
  {
    id: 'SelectAudience',
    icon: SelectAudienceStepIcon,
    title: 'selectAudience',
  },
  {
    id: 'ConnectAudience',
    icon: ConnectAudienceStepIcon,
    title: 'connectAudience',
  },
] as const satisfies ReadonlyArray<StepArgs<CreateCampaignStep>>;

export const CREATE_CAMPAIGN_STEPS_HINTS = [
  {
    stepId: 'ConnectAudience',
    hints: [
      {
        id: 'WhichUsersDoYouWannaUse',
        title: 'whichUsersDoYouWannaUse_title',
        description: 'whichUsersDoYouWannaUse_description',
      },
      {
        id: 'SearchAudienceByName',
        title: 'searchAudienceByName_title',
        description: 'searchAudienceByName_description',
      },
    ],
  },
] as const satisfies ReadonlyArray<CreateCampaignStepHints>;
